var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAppLogoOsmand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7C0 3.13401 3.13401 0 7 0H33C36.866 0 40 3.13401 40 7V33C40 36.866 36.866 40 33 40H7C3.13401 40 0 36.866 0 33V7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 1H7C3.68629 1 1 3.68629 1 7V33C1 36.3137 3.68629 39 7 39H33C36.3137 39 39 36.3137 39 33V7C39 3.68629 36.3137 1 33 1ZM7 0C3.13401 0 0 3.13401 0 7V33C0 36.866 3.13401 40 7 40H33C36.866 40 40 36.866 40 33V7C40 3.13401 36.866 0 33 0H7Z",
    fill: "#E6E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 19C33 24.3866 29.7239 29.008 25.0556 30.9804C22.6423 32 21.8056 32.5417 21.0833 33.9861C21.013 34.1268 20.953 34.2606 20.8972 34.3849C20.6665 34.8988 20.5089 35.25 20 35.25C19.4911 35.25 19.3335 34.8988 19.1028 34.3849C19.047 34.2606 18.987 34.1268 18.9167 33.9861C18.1944 32.5417 17.2917 32 14.9444 30.9804C10.2761 29.008 7 24.3866 7 19C7 11.8203 12.8203 6 20 6C27.1797 6 33 11.8203 33 19ZM27.2222 19C27.2222 22.9887 23.9887 26.2222 20 26.2222C16.0113 26.2222 12.7778 22.9887 12.7778 19C12.7778 15.0113 16.0113 11.7778 20 11.7778C23.9887 11.7778 27.2222 15.0113 27.2222 19Z",
    fill: "url(#paint0_linear_1470_9368)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1470_9368",
    x1: 20,
    y1: 6,
    x2: 20,
    y2: 35.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA033"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAppLogoOsmand);
export default __webpack_public_path__ + "static/media/ic_app_logo_osmand.11982b2a0ad8540b73a5df7a6b5da648.svg";
export { ForwardRef as ReactComponent };